import type { EntityType } from '@fd/schemas';

/** The date a record is filed under locally (range queries on the transaction list). */
export function dateKeyOf(type: EntityType, entity: Record<string, unknown> | null): string | null {
  if (!entity) return null;
  if (type === 'transaction' || type === 'investmentEvent') return (entity.bookingDate as string) ?? null;
  if (type === 'settlement') return (entity.settledOn as string) ?? null;
  return null;
}
